export default class FiltroUtils {
	static setarFiltro(filtro, chaves) {
		for (const chave in chaves) {
			if (chave in filtro) {
				filtro[chave] = chaves[chave]
			}
		}
	}

	static limparFiltro(filtro) {
		Object.keys(filtro).forEach((prop) => {
			filtro[prop] = null
		})
	}

	static limparFiltroAvancado(filtro) {
		Object.keys(filtro).forEach((key) => {
			filtro[key].value = filtro[key].default
		})
	}
}
